module.exports = __webpack_public_path__ + "static/media/Icona_Recintes_Dotze_de_juny.cfb9ed2e.png";